import { IMG } from "../../lib/assets";

const credentials = [
  "Master Hypnotherapist",
  "Certified Therapist",
  "Angel Investor",
  "Rapid Resolution Therapy",
  "Intercultural Communication Degree",
  "Priestess of the Red Rose lineage",
];

const milestones = [
  { n: "14", l: "Years in Business" },
  { n: "19", l: "Sold Out Retreats" },
  { n: "13+", l: "Countries Mentored" },
];

export const AboutJ = () => {
  return (
    <section
      className="relative py-28 md:py-40 overflow-hidden"
      data-testid="about-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-24">
            <div className="relative aspect-[3/4] overflow-hidden rounded-2xl shadow-ambient">
              <img
                src={IMG.bioWarm}
                alt="J Muenz portrait"
                className="img-warm w-full h-full object-cover"
                data-testid="about-image"
              />
            </div>

            <div className="grid grid-cols-3 gap-4 mt-8">
              {milestones.map((m) => (
                <div key={m.l} className="border-t border-[#C9587E]/30 pt-4">
                  <div className="font-serif text-3xl md:text-4xl font-light text-[#C9587E]">
                    {m.n}
                  </div>
                  <div className="font-body uppercase tracking-[0.15em] text-[9px] md:text-[10px] text-[#97808A] mt-2">
                    {m.l}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <p className="font-body uppercase tracking-[0.3em] text-[10px] text-[#C9587E] font-semibold mb-6">
              About J&hellip;
            </p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-[#3B2630]">
              14 years extracting the
              <span className="italic text-[#C9587E]"> extraordinary</span> from
              women who already have it in them.
            </h2>

            <div className="warm-divider-h my-10" />

            <div className="font-body text-base md:text-lg text-[#6B5058] leading-relaxed space-y-5 max-w-2xl">
              <p>
                Master hypnotherapist. Certified therapist. Angel investor.
              </p>
              <p>
                Trained in rapid resolution therapy. A degree in intercultural
                communication. The lineage of a Priestess of the red rose.
              </p>
              <p>
                19 sold out retreats worldwide. Booked multiple times on
                television, podcasts and the radio. Secured a book deal.
              </p>
              <p className="font-serif italic text-xl md:text-2xl text-[#3B2630] !mt-10 leading-snug">
                Mentored thousands of women across more than 13 countries.
              </p>
              <p className="!mt-10">
                I work in the subconscious landscape&hellip; the patterns, the
                cobwebs, the places where heart-centered, spiritual women talk
                themselves out of their own momentum.
              </p>
              <p className="font-serif italic text-xl md:text-2xl text-[#C9587E] leading-snug !mt-8">
                I don&rsquo;t hand you a new belief system. I clean up the one
                that&rsquo;s been running in the background without your
                permission.
              </p>
            </div>

            <div className="mt-12">
              <p className="font-body uppercase tracking-[0.3em] text-[10px] text-[#C9587E] font-semibold mb-6">
                Modalities & Lineage
              </p>
              <div className="flex flex-wrap gap-3">
                {credentials.map((c) => (
                  <span
                    key={c}
                    className="rounded-full border border-[#C9587E]/30 bg-[#FFFCFB] px-5 py-2 font-body text-xs uppercase tracking-[0.15em] text-[#6B5058]"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
